import React, { ReactNode } from 'react';
import { SpaceProps } from 'styled-system';

import { Box } from 'components/Box';
import { FacebookButton, GoogleButton } from 'components/Button';
import Divider from 'components/Divider';
import {
  FormContainer as Form,
  GeneralError,
  InputField,
  SubmitButton,
} from 'components/Form';
import InfoBox from 'components/InfoBox';
import Link, { RouterLink } from 'components/Link';
import { BodySmall } from 'components/Text';
import { trackClicked } from 'utils/analytics';
import { deleteCookie } from 'utils/cookies';
import { isDefined } from 'utils/functional';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const LoginForm = ({
  initialValues,
  thirdPartyLoginError,
  isModal,
  showSignupModal,
  getSignupUrl,
  signUpOverrideFn,
  showForgotPasswordModal,
  getForgotPasswordUrl,
  getThirdPartyLoginUrl,
  submitLogin,
  header,
  centered,
  initialWarning,
  compactView,
}: {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialValues: Record<string, any>;
  thirdPartyLoginError: string | null | undefined;
  isModal?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showSignupModal: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSignupUrl: (arg0: string) => string | Record<string, any>;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  signUpOverrideFn?: (...args: Array<any>) => any;
  showForgotPasswordModal: (arg0: {
    email: string;
    showUnsupportedServiceMessage?: boolean;
  }) => void;
  getForgotPasswordUrl: (arg0: {
    email: string;
    showUnsupportedServiceMessage?: boolean;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }) => Record<string, any>;
  getThirdPartyLoginUrl: (
    arg0: 'facebook' | 'google'
  ) => Promise<string> | string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  submitLogin: (...args: Array<any>) => any;
  header?: ReactNode;
  centered?: boolean;
  initialWarning?: string | null | undefined;
  compactView?: boolean;
}) => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/function-component-definition, react/no-unstable-nested-components
  const SignupLink = ({
    children,
    email,
  }: {
    children: ReactNode;
    email: string;
  }) => {
    if (signUpOverrideFn) {
      return (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault();
            trackClicked('Sign Up');
            signUpOverrideFn();
          }}
          data-qa-id="signup-link"
        >
          {children}
        </Link>
      );
    }

    if (isModal) {
      return (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault();
            trackClicked('Sign Up');
            showSignupModal(email);
          }}
          data-qa-id="signup-link"
        >
          {children}
        </Link>
      );
    }

    return (
      <RouterLink
        to={getSignupUrl(email)}
        onClick={() => {
          trackClicked('Sign Up');
        }}
        data-qa-id="signup-link"
      >
        {children}
      </RouterLink>
    );
  };

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/function-component-definition, react/no-unstable-nested-components
  const ForgotPasswordLink = ({
    email,
    showUnsupportedServiceMessage,
    ...spaceProps
  }: SpaceProps & {
    children: ReactNode;
    email: string;
    showUnsupportedServiceMessage?: boolean;
  }) => {
    if (isModal) {
      return (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          href="#"
          onClick={(e) => {
            e.preventDefault();
            showForgotPasswordModal({
              email,
              showUnsupportedServiceMessage,
            });
          }}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...spaceProps}
        />
      );
    }

    return (
      <RouterLink
        to={getForgotPasswordUrl({
          email,
          showUnsupportedServiceMessage,
        })}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...spaceProps}
      />
    );
  };

  return (
    <Form
      data-qa-id="login-form"
      initialValues={initialValues}
      onSubmit={submitLogin}
      noScrollToError
      render={({ values: { email } }) => (
        <Box textAlign={centered ? 'center' : 'left'}>
          {initialWarning && (
            <InfoBox type="warning" mt="20px" mb="20px">
              {initialWarning}
            </InfoBox>
          )}
          {isDefined(header)
            ? header
            : !initialWarning && (
                <BodySmall as="p" mt={3} mb={4}>
                  {getText('Log in or create your account to get started.')}
                </BodySmall>
              )}

          {thirdPartyLoginError && (
            <InfoBox className="error" type="danger" mb={4}>
              {thirdPartyLoginError}
            </InfoBox>
          )}

          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent={centered ? 'center' : 'flex-start'}
            mb={4}
            mt="-6px"
            mx="-6px"
          >
            <Box m="6px">
              <GoogleButton
                onClick={async (e) => {
                  deleteCookie('userDismissedNotificationPreferencesDialog');
                  e.preventDefault();
                  const url = await getThirdPartyLoginUrl('google');
                  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Location'... Remove this comment to see the full error message
                  window.location = url;
                }}
                data-qa-id="google-oauth"
              />
            </Box>

            <Box m="6px">
              <FacebookButton
                onClick={async (e) => {
                  deleteCookie('userDismissedNotificationPreferencesDialog');
                  e.preventDefault();
                  const url = await getThirdPartyLoginUrl('facebook');
                  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Location'... Remove this comment to see the full error message
                  window.location = url;
                }}
                data-qa-id="facebook-oauth"
              />
            </Box>
          </Box>

          {!compactView && <Divider my={24} />}

          <GeneralError />

          <InputField
            name="email"
            type="email"
            data-modal-focus={isModal ? 'true' : null}
            placeholder={getText('casey.smith@example.com')}
            label={
              /* TRANSLATORS: Login form */
              getText('Email')
            }
          />

          <InputField
            name="password"
            type="password"
            label={
              /* TRANSLATORS: Login form */
              getText('Password')
            }
          />

          <Box mt={[16, null, 40]}>
            <SubmitButton width="100%" size="large">
              {
                /* TRANSLATORS: log in button */
                getText('Log in')
              }
            </SubmitButton>
          </Box>

          <Box mt={[16, null, 32]}>
            <BodySmall textAlign="center">
              <Box>
                {getText("Don't have an account?")}{' '}
                <SignupLink email={email}>{getText('Sign up')}</SignupLink>
              </Box>
              <Box mt="8px">
                <ForgotPasswordLink mt={2} email={email}>
                  {getText('I forgot my password')}
                </ForgotPasswordLink>
              </Box>
              <Box mt="8px">
                <ForgotPasswordLink showUnsupportedServiceMessage email={email}>
                  {getText('Looking for Yahoo, Microsoft, Twitter login?')}
                </ForgotPasswordLink>
              </Box>
            </BodySmall>
          </Box>
        </Box>
      )}
    />
  );
};

// eslint-disable-next-line import/no-default-export
export default LoginForm;
